import AxiosDefault from "services/AxiosDefault";

export const GetBallparkLocationsAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/settings/ballpark/getLocations",
    data,
  });
  return response;
};

export const RegisterOnBallparkAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/public/other/ballpark/subscription/register",
    data,
  });
  return response;
};

export const RegisterParkingOnBallparkAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/public/other/ballpark/parking/register",
    data,
  });
  return response;
};

export const RegisterPermitOnBallparkAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/public/other/ballpark/permit/register",
    data,
  });
  return response;
};
